import type { SVGProps } from "react";
const SvgTarget02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M17 12a5 5 0 1 1-5-5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M14 2.2q-.97-.198-2-.2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10q-.002-1.03-.2-2"
    />
    <path
      fill="currentColor"
      d="M11.47 11.47a.75.75 0 1 0 1.06 1.06L12 12zm8.22-7.16-.725.188a.75.75 0 0 0 .537.537zm-.516-1.98-.725.19zm-.876-.14.53.53zm-1.15 1.15-.53-.53zm-.87 2.811-.726.19zm5.392-1.326-.19.726zm.14.877-.53-.53zm-1.15 1.15.53.53zm-2.811.87-.19.726zm-1.246-.325-.53-.53-4.603 4.603.53.53.53.53 4.604-4.603zm3.088-3.088.726-.19-.517-1.978-.726.19-.725.188.516 1.98zM18.298 2.19l-.53-.53-1.15 1.15.53.53.531.53 1.15-1.15zm-2.02 3.961-.726.19.325 1.245.726-.19.726-.188-.325-1.246zm3.413-1.842-.19.726 1.98.516.189-.726.19-.725-1.98-.517zm2.119 1.393-.53-.53-1.15 1.149.53.53.53.53 1.15-1.149zm-3.961 2.02.19-.726-1.247-.325-.189.726-.19.726 1.246.325zm2.812-.87-.53-.531c-.622.621-1.445.844-2.093.675l-.19.726-.189.726c1.24.323 2.594-.128 3.532-1.066zm1.009-2.027-.19.726a.32.32 0 0 1-.227-.248c-.013-.083.02-.125.027-.131l.53.53.53.53c.313-.312.461-.744.394-1.165a1.18 1.18 0 0 0-.875-.967zM17.149 3.34l-.53-.53c-.94.939-1.39 2.293-1.067 3.532l.726-.19.726-.19c-.17-.647.054-1.47.675-2.091zm2.025-1.009.726-.19a1.18 1.18 0 0 0-.967-.874 1.35 1.35 0 0 0-1.165.394l.53.53.53.53c-.006.007-.048.04-.131.027a.32.32 0 0 1-.248-.228z"
    />
  </svg>
);
export default SvgTarget02;
